module.exports = __webpack_public_path__ + "static/media/law.fd1d01c5.webp";